var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgYoutubeGrey(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.922,
    height: 22.787,
    viewBox: "0 0 28.922 22.787",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M24.54,22.787H4.382A4.387,4.387,0,0,1,0,18.4V4.382A4.387,4.387,0,0,1,4.382,0H24.54a4.387,4.387,0,0,1,4.382,4.382V18.4A4.387,4.387,0,0,1,24.54,22.787ZM11.394,7.011v8.852l7.428-4.521Z",
    fill: "#a6a6a6"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeGrey);
export default __webpack_public_path__ + "static/media/youtube-grey.f2ec68a3422770530be56d15c443e266.svg";
export { ForwardRef as ReactComponent };